export const SUPPORTED_LOCALES = ["uk", "ru", "en"] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];
export const DEFAULT_LOCALE: SupportedLocale = "uk";

export function normalizeTelegramLocale(languageCode?: string | null): SupportedLocale {
  const raw = String(languageCode ?? "")
    .trim()
    .toLowerCase()
    .replace(/_/g, "-");
  if (!raw) {
    return DEFAULT_LOCALE;
  }
  const base = raw.split("-")[0] ?? raw;
  if (base === "uk" || base === "ua") {
    return "uk";
  }
  if (base === "ru") {
    return "ru";
  }
  if (base === "en") {
    return "en";
  }
  return DEFAULT_LOCALE;
}
